import React, { Component } from 'react';
import {
    ButtonDropdown,
    CustomInput,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Button,
    Collapse,
} from 'reactstrap';
import { connect } from 'react-redux';
import {
    setContainerClassnames,
    clickOnMobileMenu,
} from '../../../redux/actions';
import IntlMessages from '../../../helpers/IntlMessages';
import classnames from 'classnames';
import { UpdateMobile } from '../general';
import ContentDisplayMobile from './ContentDisplayMobile';
import { Separator } from '../../../components/common/CustomBootstrap';
import { AddCommaNumber } from '../../../helpers/Utils';

class LabelItemLeft extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dropdownSplitOpen: false,
        };
    }

    toggleSplit = () => {
        this.setState((prevState) => ({
            dropdownSplitOpen: !prevState.dropdownSplitOpen,
        }));
    };

    menuButtonClick = (e, menuClickCount, containerClassnames) => {
        setTimeout(() => {
            var event = document.createEvent('HTMLEvents');
            event.initEvent('resize', false, false);
            window.dispatchEvent(event);
        }, 350);
        this.props.setContainerClassnames(
            menuClickCount,
            containerClassnames,
            this.props.selectedMenuHasSubItems
        );
    };

    onClickedItem = (item) => {
        this.props.onClickedItem(
            // callback
            item,
            this.menuButtonClick,
            [null, 1000, this.props.containerClassnames]
        );
    };

    render() {
        const { dropdownSplitOpen } = this.state;
        const { item } = this.props;
        const items = item.company_provider_item || [];
        const totalImport = items.reduce(
            (acc, curr) => acc + (parseFloat(curr.price_income) || 0),
            0
        );
        const totalDebt = items.reduce(
            (acc, curr) =>
                acc +
                ((parseFloat(curr.price_income) || 0) -
                    (parseFloat(curr.price_outcome) || 0)),
            0
        );
        const firstItemName = items.length > 0 ? items[0].name : 'Chưa phân loại';
        const hasDebt = totalDebt > 0;
        // console.log(this.props.item);
        return (
            <div className='custom-shadow provider-mobile-card'>
                <div className='provider-mobile-card-header'>
                    <CustomInput
                        className='custom-checkbox mb-0'
                        type='checkbox'
                        id={this.props.idx}
                        checked={this.props.selectedItems.includes(
                            this.props.item.id
                        )}
                        onChange={() => {
                            this.props.onChangeCheckbox(this.props.item.id);
                        }}
                        label=''
                    />
                    <button
                        type='button'
                        className='provider-mobile-card-main'
                        onClick={() => {
                            this.onClickedItem(this.props.item);
                        }}
                    >
                        <span className='provider-mobile-name'>
                            {this.props.item.name || this.props.item.phone || 'Nhà cung cấp'}
                        </span>
                        <span className='provider-mobile-meta'>
                            {this.props.item.phone || 'Chưa có SĐT'} · {firstItemName}
                        </span>
                    </button>
                    <div className='provider-mobile-menu'>
                            <ButtonDropdown
                                isOpen={dropdownSplitOpen}
                                toggle={this.toggleSplit}
                            >
                                <DropdownToggle
                                    tag='button'
                                    className='provider-mobile-menu-btn'
                                >
                                    <i className='simple-icon-options-vertical' />
                                </DropdownToggle>
                                <DropdownMenu right>
                                    <DropdownItem
                                        className={classnames('text-left', {
                                            disable:
                                                this.props.isDisabledUpdate,
                                        })}
                                        onClick={() =>
                                            this.props.isDisabledUpdate
                                                ? null
                                                : this.props.onUpdate(
                                                      this.props.item
                                                  )
                                        }
                                    >
                                        <i className='simple-icon-note pr-2' />
                                        <IntlMessages id='pages.update' ˇ />
                                    </DropdownItem>
                                    <Separator />
                                    <DropdownItem
                                        className={classnames('text-left red', {
                                            disable:
                                                this.props.isDisabledDelete,
                                        })}
                                        onClick={() =>
                                            this.props.isDisabledDelete
                                                ? null
                                                : this.props.onDelete(
                                                      this.props.item
                                                  )
                                        }
                                    >
                                        <>
                                            <i className='simple-icon-trash pr-2' />
                                            <IntlMessages id='pages.delete' />
                                        </>
                                    </DropdownItem>
                                </DropdownMenu>
                            </ButtonDropdown>
                    </div>
                </div>
                <div className='provider-mobile-stats'>
                    <div>
                        <span>Tổng nhập</span>
                        <strong>{AddCommaNumber(totalImport)}đ</strong>
                    </div>
                    <div>
                        <span>Công nợ</span>
                        <strong className={classnames({ 'text-danger': hasDebt })}>
                            {AddCommaNumber(Math.max(totalDebt, 0))}đ
                        </strong>
                    </div>
                    <div>
                        <span>Trạng thái</span>
                        <strong className={hasDebt ? 'text-warning' : 'text-success'}>
                            {hasDebt ? 'Còn nợ' : totalImport > 0 ? 'Đã trả hết' : 'Chưa GD'}
                        </strong>
                    </div>
                </div>

                <Collapse isOpen={this.props.accordion[this.props.idx]}>
                    <div className='card-body accordion-content pt-0 overflow-hidden'>
                        <Separator />
                        <UpdateMobile>
                            <ContentDisplayMobile
                                // data_dynamic_form={data_dynamic_form}
                                // data_tags={this.props.data_tags}
                                values={this.props.form}
                            />
                        </UpdateMobile>
                    </div>
                </Collapse>
            </div>
        );
    }
}

const mapStateToProps = ({ menu }) => {
    const { containerClassnames, menuClickCount, selectedMenuHasSubItems } =
        menu;
    return {
        containerClassnames,
        menuClickCount,
        selectedMenuHasSubItems,
    };
};
export default connect(mapStateToProps, {
    setContainerClassnames,
    clickOnMobileMenu,
})(LabelItemLeft);
